import * as React from 'react'
import { PropsWithChildren, ReactElement, useEffect } from 'react'
import { useFormikContext } from 'formik'
import { useBoolean } from '@fluentui/react-hooks'

type Props = PropsWithChildren<{
    fieldName: string
    pinnedFieldName: string
    getPinnedValue: () => string
}>

export default function PinnerInputField({ fieldName, pinnedFieldName, getPinnedValue, children }: Props): ReactElement {
    const {
        values: { [fieldName]: value },
        initialValues: { [pinnedFieldName]: pinnedValue },
        setFieldValue,
    } = useFormikContext<any>()
    const [isMount, { setFalse: setHasMounted }] = useBoolean(true)

    useEffect(() => {
        // Only set the pinned field if the field is not mounting or if there is no initial pinned value.
        if (!isMount || !pinnedValue) {
            setFieldValue(pinnedFieldName, getPinnedValue())
        }
        setHasMounted()
    }, [value])

    return <>{children}</>
}
